<template>
  <div id="wl-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>